<div class="feedback-template-container" [class.empty]="dataSource.length === 0">
  @for (row of dataSource; track row.id; let i = $index) {
  <div [class]="getDragClasses(i)" 
       draggable="true"
       (dragstart)="onDragStart($event, i)"
       (dragover)="onDragOver($event, i)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event, i)"
       (dragend)="onDragEnd()"
       class="feedback-row-container">
    
    <!-- Drag Handle -->
    <div class="drag-handle-cell">
      <owc-icon family="outlined" name="drag_indicator" class="drag-handle-icon"></owc-icon>
    </div>

    <!-- Question Type Column -->
    <div class="question-type-cell">
      <ng-container *ngIf="!shouldShowFormControls(row, i); else editableSelectType">
        <div class="display-field">
          <span>{{ row.selectType }}</span>
          <owc-icon name="expand_more" class="dropdown-icon"></owc-icon>
        </div>
      </ng-container>
      <ng-template #editableSelectType>
        <owc-select-dropdown 
          [formControl]="selectTypeFormControl" 
          [placeholder]="selectPlaceholder"
          variant="outlined" 
          size="medium" 
          class="select-dropdown">
          <owc-list-item *ngFor="let item of selectTypeList" [value]="item.label">
            {{ item.label }}
          </owc-list-item>
        </owc-select-dropdown>
      </ng-template>
    </div>
    <!-- Question Text Column -->
    <div class="question-text-cell" 
         [class.span-two-columns]="shouldShowFormControls(row, i) && (getFormControlValue(selectTypeFormControl) !== 'Dropdown' && getFormControlValue(selectTypeFormControl) !== 'Radio')">
      <ng-container *ngIf="!shouldShowFormControls(row, i); else editableSelectText">
        <div class="display-field question-text">
          {{ row.selectText }}
        </div>
      </ng-container>
      <ng-template #editableSelectText>
        <div class="input-with-options">
          <owc-input 
            type="text"
            [formControl]="selectTextFormControl"
            placeholder="Enter text..."
            variant="outlined"
            class="text-input">
          </owc-input>
          <owc-button 
            *ngIf="getFormControlValue(selectTypeFormControl) === 'Dropdown' || getFormControlValue(selectTypeFormControl) === 'Radio'" 
            (click)="dropDownFn(i, row)"
            size="small"
            class="options-button">
            Options ({{ row.dropDownOpt?.length || 0 }})
          </owc-button>
        </div>
      </ng-template>
    </div>

    <!-- Options Column (for Dropdown/Radio) -->
    <div class="mandatory-cell options-cell" 
         [class.hidden]="row.selectType !== 'Dropdown' && row.selectType !== 'Radio'">
      <ng-container *ngIf="(row.selectType === 'Dropdown' || row.selectType === 'Radio') && row.selectText">
        <div class="display-field">
          <span>Options ({{ row.dropDownOpt?.length || 0 }})</span>
        </div>
      </ng-container>
    </div>

    <!-- Mandatory/Optional Column -->
    <div class="mandatory-cell">
      <ng-container *ngIf="!shouldShowFormControls(row, i); else editableMandatory">
        <div class="display-field">
          <span>{{ row.selectMandatory }}</span>
          <owc-icon name="expand_more" class="dropdown-icon"></owc-icon>
        </div>
      </ng-container>
      <ng-template #editableMandatory>
        <owc-select-dropdown 
          [formControl]="selectMandatoryFC" 
          [placeholder]="selectMandatoryPlaceholder"
          variant="outlined" 
          size="medium" 
          class="select-dropdown">
          <owc-list-item *ngFor="let item of selectMandatoryList" [value]="item.label">
            {{ item.label }}
          </owc-list-item>
        </owc-select-dropdown>
      </ng-template>
    </div>

    <!-- Actions Column -->
    <div class="actions-cell">
      <ng-container *ngIf="row.iconSets === 'yes-icon'">
        <owc-button style="border: none; background: none;"
          (click)="!isConfirmButtonDisabled(row, getFormControlValue(selectTypeFormControl), selectTextFormControl.value) && addNewFeedbackOption(row, i, getFormControlValue(selectTypeFormControl), selectTextFormControl.value, getFormControlValue(selectMandatoryFC))"
          [class.button-disabled]="isConfirmButtonDisabled(row, getFormControlValue(selectTypeFormControl), selectTextFormControl.value)"
          color="primary"
          size="small"
          class="confirm-button">
         <owc-icon name="confirm" family="outlined"></owc-icon>
        </owc-button>
      </ng-container>

      <ng-container *ngIf="row.iconSets === 'more-icon'">
        <owc-icon-button 
          family="outlined" 
          [id]="'menu-anchor-' + i" 
          icon="more_horizontal"
          class="more-button">
        </owc-icon-button>
        <owc-menu [anchor]="'menu-anchor-' + i" position="left">
          <owc-list-item (click)="EditFeedbackFromTemplate(row, i)">Edit</owc-list-item>
          <owc-list-item (click)="deleteFeedbackFromTemplate(row, i)">Delete</owc-list-item>
        </owc-menu>
      </ng-container>

      <ng-container *ngIf="row.iconSets === 'delete-icon'">
        <owc-icon-button 
          (click)="deleteFeedbackFromTemplate(row, i)"
          icon="delete"
          family="outlined"
          class="delete-button">
        </owc-icon-button>
      </ng-container>
    </div>
    
  </div>
}

</div>

<owc-modal-dialog 
  *ngIf="dropdownDialogVisible" 
  [visible]="dropdownDialogVisible"
  headline="Configure Dropdown Options"
  size="medium">
  <dl-cf-feedback-template-dropdown 
    [data]="currentEditElement?.dropDownOpt || []"
    [feedbackType]="currentEditElement?.selectType || 'Dropdown'"
    (confirmEvent)="onDropdownDialogConfirm($event)"
    (cancelEvent)="onDropdownDialogCancel()">
  </dl-cf-feedback-template-dropdown>
</owc-modal-dialog>
